'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _katex = require('katex');

var _katex2 = _interopRequireDefault(_katex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestionsListItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(QuestionsListItem, _Component);

  function QuestionsListItem() {
    (0, _classCallCheck3.default)(this, QuestionsListItem);
    return (0, _possibleConstructorReturn3.default)(this, (QuestionsListItem.__proto__ || (0, _getPrototypeOf2.default)(QuestionsListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuestionsListItem, [{
    key: 'render',
    value: function render() {
      var styles = require('./QuestionsListItem.scss');
      var _props = this.props,
          dragHandle = _props.dragHandle,
          item = _props.item,
          itemSelected = _props.itemSelected;

      var dragged = itemSelected > 0.75;
      var innerHTML = function innerHTML(html) {
        var htmlClone = html.substr(0);
        var katexHtml = void 0;

        try {
          katexHtml = htmlClone.replace(/\$(.*?)\$/g, function (outer, inner) {
            return _katex2.default.renderToString(inner, { throwOnError: true });
          });
        } catch (error) {
          katexHtml = error.message;
        }

        return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: katexHtml } });
      };

      return _react2.default.createElement(
        'div',
        { className: styles.questionsListItem + (dragged ? ' dragged' : '') },
        dragHandle(_react2.default.createElement('div', { className: styles.dragHandle })),
        _react2.default.createElement(
          'div',
          { className: styles.questionTitle },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'i',
              { className: styles.questionNumber },
              item.rank
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            innerHTML(item.question)
          )
        )
      );
    }
  }]);
  return QuestionsListItem;
}(_react.Component), _class.propTypes = {
  dragHandle: _react.PropTypes.func.isRequired,
  item: _react.PropTypes.object.isRequired,
  itemSelected: _react.PropTypes.number.isRequired
}, _temp);
exports.default = QuestionsListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuestionsListItem/QuestionsListItem.js
// module id = 1181
// module chunks = 0